/** Where page copy lives: `/page-copy` and `/page-copy/:namespace` (moved from Settings). */
export const PAGE_COPY_BASE = '/page-copy';
